import { useEffect, useState } from "react";
import Footer from "../../components/footer"
import Navbar from "../../components/hero/components/navbar"
import BookingFormDetails from "../../components/booking-page/BookingFormDetails";






export const EratekDiscoveryBookingPage = () => {

  const [title, setTitle] = useState(`Eratek | Discovery Call`);

  useEffect(() => {
    document.title = title;
    setTitle(title);
  }, [title]);



  return (
    <>
      <Navbar />
      <BookingFormDetails />
      <Footer />
    </>
  )
}